import * as z from "zod";

export const getCheckoutOptimizationAnalyticsAssumptions = {
  name: "getCheckoutOptimizationAnalyticsAssumptions" as const,
  input: z.null(),
  output: z.object({ annualOrders: z.number().optional() }),
};
